export const gridColumnCount = 12;
export const gutterHalf = '4px';
//# sourceMappingURL=constants.js.map